function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewStory1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 493.7 992.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 493.7,
    height: 992.7,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "overview-story1-phone",
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M483.9,68.4v855.8c0,3-.2,5.9-.7,8.9-.1.7-.2,1.4-.4,2.1-.7,3.6-1.7,7-3,10.4-.3.7-.5,1.4-.8,2-1.9,4.2-4.2,8.2-6.9,11.8-.3.3-.5.7-.8,1-1.9,2.4-4,4.7-6.2,6.8-.9.8-1.9,1.7-2.8,2.4-.3.3-.7.6-1,.8-1,.8-2.1,1.6-3.2,2.3,0,0-.1,0-.2.2-.7.4-1.3.9-2,1.3-.8.5-1.5.9-2.3,1.3s-1.6.8-2.4,1.2c-.4.2-.8.4-1.2.6-.4.2-.8.4-1.2.5-1.2.5-2.5,1-3.7,1.5-.8.3-1.7.6-2.5.8-.4.1-.9.3-1.3.4-1.3.3-2.6.7-4,1-.4,0-.9.2-1.3.3s-.9.2-1.3.2c-.9.2-1.8.3-2.7.4-.6,0-1.3.1-1.9.2-.5,0-1.1,0-1.6,0-1,0-2,0-3,0H68.5c-1,0-2,0-3.1,0-.5,0-1.1,0-1.6,0-1,0-2.1-.2-3.1-.3.4,0,.8,0,1.2.1-29.6-3.4-52-28.5-52-58.3V68.4c0-31.2,24.5-56.9,55.6-58.5h0c1,0,2,0,3,0h356.8c1,0,2,0,3,0h0c.5,0,1.1,0,1.6.1.5,0,1,0,1.6.1,29.8,3.2,52.4,28.4,52.4,58.3",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M483.9,68.4v855.8c0,3-.2,5.9-.7,8.9-.1.7-.2,1.4-.4,2.1-.7,3.6-1.7,7-3,10.4-.3.7-.5,1.4-.8,2-1.9,4.2-4.2,8.2-6.9,11.8-.3.3-.5.7-.8,1-1.9,2.4-4,4.7-6.2,6.8-.9.8-1.9,1.7-2.8,2.4-.3.3-.7.6-1,.8-1,.8-2.1,1.6-3.2,2.3,0,0-.1,0-.2.2-.7.4-1.3.9-2,1.3-.8.5-1.5.9-2.3,1.3s-1.6.8-2.4,1.2c-.4.2-.8.4-1.2.6-.4.2-.8.4-1.2.5-1.2.5-2.5,1-3.7,1.5-.8.3-1.7.6-2.5.8-.4.1-.9.3-1.3.4-1.3.3-2.6.7-4,1-.4,0-.9.2-1.3.3s-.9.2-1.3.2c-.9.2-1.8.3-2.7.4-.6,0-1.3.1-1.9.2-.5,0-1.1,0-1.6,0-1,0-2,0-3,0H68.5c-1,0-2,0-3.1,0-.5,0-1.1,0-1.6,0-1,0-2.1-.2-3.1-.3.4,0,.8,0,1.2.1-29.6-3.4-52-28.5-52-58.3V68.4c0-31.2,24.5-56.9,55.6-58.5h0c1,0,2,0,3,0h356.8c1,0,2,0,3,0h0c.5,0,1.1,0,1.6.1.5,0,1,0,1.6.1,29.8,3.2,52.4,28.4,52.4,58.3Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M425.2,1.8H68.4C31.6,1.8,1.8,31.6,1.8,68.4v855.8c0,36.8,29.9,66.7,66.7,66.7h356.8c36.8,0,66.7-29.8,66.7-66.7V68.4c0-36.8-29.9-66.7-66.7-66.7M465,967.3c-.9.8-1.9,1.7-2.8,2.4-.3.3-.7.6-1,.8-1,.8-2.1,1.6-3.2,2.3,0,0-.1,0-.2.2-.7.4-1.3.9-2,1.3-.8.5-1.5.9-2.3,1.3s-1.6.8-2.4,1.2c-.4.2-.8.4-1.2.6-.4.2-.8.4-1.2.5-1.2.5-2.5,1-3.7,1.5-.8.3-1.7.6-2.5.8-.4.1-.9.3-1.3.4-1.3.3-2.6.7-4,1-.4,0-.9.2-1.3.3s-.9.2-1.4.2c-.9.2-1.8.3-2.7.4-.6,0-1.3.1-1.9.2-.5,0-1.1,0-1.6,0-1,0-2,0-3,0H68.5c-1,0-2,0-3.1,0-.5,0-1.1,0-1.6,0-1,0-2.1-.2-3.1-.3.4,0,.8,0,1.2.1-29.6-3.4-52-28.5-52-58.3V68.4c0-31.2,24.5-56.9,55.6-58.5h0c1,0,2,0,3,0h356.8c1,0,2,0,3,0h0c.5,0,1.1,0,1.6.1.5,0,1,0,1.6.1,29.8,3.2,52.4,28.4,52.4,58.3v855.8c0,3-.2,5.9-.7,8.9-.1.7-.2,1.4-.4,2.1-.7,3.6-1.7,7-3,10.4-.2.7-.5,1.4-.8,2-1.9,4.2-4.2,8.2-6.9,11.8-.3.3-.5.7-.8,1-1.9,2.4-4,4.7-6.2,6.8",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M425.2,1.8H68.4C31.6,1.8,1.8,31.6,1.8,68.4v855.8c0,36.8,29.9,66.7,66.7,66.7h356.8c36.8,0,66.7-29.8,66.7-66.7V68.4c0-36.8-29.9-66.7-66.7-66.7ZM465,967.3c-.9.8-1.9,1.7-2.8,2.4-.3.3-.7.6-1,.8-1,.8-2.1,1.6-3.2,2.3,0,0-.1,0-.2.2-.7.4-1.3.9-2,1.3-.8.5-1.5.9-2.3,1.3s-1.6.8-2.4,1.2c-.4.2-.8.4-1.2.6-.4.2-.8.4-1.2.5-1.2.5-2.5,1-3.7,1.5-.8.3-1.7.6-2.5.8-.4.1-.9.3-1.3.4-1.3.3-2.6.7-4,1-.4,0-.9.2-1.3.3s-.9.2-1.4.2c-.9.2-1.8.3-2.7.4-.6,0-1.3.1-1.9.2-.5,0-1.1,0-1.6,0-1,0-2,0-3,0H68.5c-1,0-2,0-3.1,0-.5,0-1.1,0-1.6,0-1,0-2.1-.2-3.1-.3.4,0,.8,0,1.2.1-29.6-3.4-52-28.5-52-58.3V68.4c0-31.2,24.5-56.9,55.6-58.5h0c1,0,2,0,3,0h356.8c1,0,2,0,3,0h0c.5,0,1.1,0,1.6.1.5,0,1,0,1.6.1,29.8,3.2,52.4,28.4,52.4,58.3v855.8c0,3-.2,5.9-.7,8.9-.1.7-.2,1.4-.4,2.1-.7,3.6-1.7,7-3,10.4-.2.7-.5,1.4-.8,2-1.9,4.2-4.2,8.2-6.9,11.8-.3.3-.5.7-.8,1-1.9,2.4-4,4.7-6.2,6.8Z",
    style: {
      fill: "none",
      stroke: "#212121",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M270.8,42.5h-50.9c-1.6,0-3-1.3-3-3s1.3-3,3-3h50.9c1.6,0,3,1.3,3,3s-1.3,3-3,3h0",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M270.8,42.5h-50.9c-1.6,0-3-1.3-3-3s1.3-3,3-3h50.9c1.6,0,3,1.3,3,3s-1.3,3-3,3h0Z",
    style: {
      fill: "none",
      stroke: "#212121",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M427.6,32.8h-.8c-.6,0-1.1,0-1.6,0h-51.5c-2.9.2-5.3,2.4-5.6,5.3,0,.2,0,.4,0,.6h0c-.7,15.2-13.2,27.2-28.4,27.2h-185.7c-15.2,0-27.7-11.9-28.4-27.1h0c0-.3,0-.5,0-.7-.3-2.9-2.7-5.2-5.6-5.3h-51.5c-.5,0-1,0-1.6,0h-.5s-.3,0-.3,0c-18.8,1.3-33.4,16.8-33.4,35.7v855.8c0,18.6,14.4,34.1,32.9,35.6.2,0,.3,0,.5,0h.2s.2,0,.2,0h0c.6,0,1.2,0,1.8,0h356.8c.6,0,1.2,0,1.9,0h0s.2,0,.2,0h.1s.1,0,.1,0c.1,0,.3,0,.5,0,18.5-1.5,32.8-17,32.9-35.6V68.4c0-18.8-14.6-34.4-33.3-35.7",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M427.6,32.8h-.8c-.6,0-1.1,0-1.6,0h-51.5c-2.9.2-5.3,2.4-5.6,5.3,0,.2,0,.4,0,.6h0c-.7,15.2-13.2,27.2-28.4,27.2h-185.7c-15.2,0-27.7-11.9-28.4-27.1h0c0-.3,0-.5,0-.7-.3-2.9-2.7-5.2-5.6-5.3h-51.5c-.5,0-1,0-1.6,0h-.5s-.3,0-.3,0c-18.8,1.3-33.4,16.8-33.4,35.7v855.8c0,18.6,14.4,34.1,32.9,35.6.2,0,.3,0,.5,0h.2s.2,0,.2,0h0c.6,0,1.2,0,1.8,0h356.8c.6,0,1.2,0,1.9,0h0s.2,0,.2,0h.1s.1,0,.1,0c.1,0,.3,0,.5,0,18.5-1.5,32.8-17,32.9-35.6V68.4c0-18.8-14.6-34.4-33.3-35.7Z",
    style: {
      fill: "none",
      stroke: "#121211",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "overview-story1-chevronL",
    id: "Path_486",
    "data-name": "Path 486",
    d: "M206.1,519.7v-65h65",
    style: {
      fill: "none",
      stroke: "#e4a05d",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "overview-story1-chevronR",
    id: "Path_487",
    "data-name": "Path 487",
    d: "M299.5,487.3v65h-65",
    style: {
      fill: "none",
      stroke: "#e4a05d",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewStory1);
export default __webpack_public_path__ + "static/media/overview-story1.0a155719.svg";
export { ForwardRef as ReactComponent };